import React, { useState, useEffect } from "react";
import { mapTableRows } from "../../../../../utils";
import AddAccountModel from "../../Modals/AddAccountModel";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { usePagination } from "../../../../../hooks";
import {
  Button,
  DropdownMenuNew,
  LogoLoader,
  showToast,
  TableAdv,
} from "../../../../../components";
import AddBulkList from "../../Modals/BulkEmailsModal/AddBulkList";
import { totalCountStart } from "../../../../../redux/slices/totalCount/totalCountSlice";
import {
  deleteIntegration,
  getAllIntegrations,
  updateIntegrations,
} from "../../../../../redux/slices/setting/settingApi";
import {
  deleteIntegrationBs,
  getAllIntegrationsBs,
  getGmailAccountsBs,
  getOutlookAccountsBs,
  getTotalEmailCountApi,
  updateIntegrationsBs,
  updateIntegrationsBsMail,
} from "../../../../../redux/slices/ats/benchSales/benchSalesApi";
import { formatWords2 } from "../../../../../utils/stringUtils";
import { getAllIntegrationsNm, updateIntegrationsNm } from "../../../../../redux/slices/nonitMarketing/nonitMarketingApi";

const BulkEmail = ({
  category,
  type,
  integrations,
  onUpdate,
  selectedModule,
}) => {
  const [showConnectModal, setShowConnectModal] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [integrationData, setIntegrationData] = useState([]);
  const [valueChange, setValueChange] = useState(false);
  const [integrationAccess, setIntegrationAccess] = useState({});
  const [editData, setEditData] = useState();
  const [isEdit, setIsEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [bsTotalCount, setBsTotalCount] = useState(0);

  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {},
  );

  const dispatch = useDispatch();
  const location = useLocation();
  const integrationKey = `${category}-${type}`;
  const integration = integrations[integrationKey];
  const { value } = useSelector((state) => state.totalCount);
  // const totalCount = selectedModule === "bs" ? value?.integrationCountBs?.data?.total : value?.integrationCount?.data || 0;
  const totalCount =
    selectedModule === "bs"
      ? value?.integrationCountBs?.data?.total
      :  selectedModule === "nm"
      ? value?.integrationCountNm?.data?.total:value?.integrationCount?.data || 0;

  // useEffect(() => {
  //   if (location.state?.showTable === true) {
  //     setShowTable(true);
  //   }
  // }, [location.state]);

  useEffect(() => {
    fetchIntegrationData();
  }, [dispatch, limit, page]);

  useEffect(() => {
    fetchTotalCount();
    fetchIntegrationData();
  }, [selectedModule, showConnectModal]);

  console.log(type);
  const fetchTotalCount = async () => {
    if (selectedModule === "ats") {
      dispatch(
        totalCountStart({
          collection: "integrations",
          coll: "Integration",
          tname: "integrationCount",
          filters: {
            category: { type: "NONE", value: category },
            type: { type: "NONE", value: type },
          },
          app: "ats",
        }),
      );
    } else if (selectedModule === "bs") {
      dispatch(
        totalCountStart({
          collection: "integrationbss",
          coll: "Integrationbs",
          tname: "integrationCountBs",
          filters: {
            category: { type: "NONE", value: category },
            type: { type: "NONE", value: type },
          },
          app: "bs",
        }),
      );
    }else if   (selectedModule === "nm") {
      dispatch(
        totalCountStart({
          collection: "integrationbss",
          coll: "Integrationbs",
          tname: "integrationCountNm",
          filters: {
            category: { type: "NONE", value: category },
            type: { type: "NONE", value: type },
          },
          app: "nm",
        }),
      );
    }
  };

  const fetchIntegrationData = async () => {
    try {
      setLoading(true);
      const params = {
        coll: selectedModule === "bs" ||  selectedModule === "nm"  ? "Integrationbs" : "Integration",
        fil: JSON.stringify({
          category: { type: "NONE", value: category },
          type: { type: "NONE", value: type },
        }),
        lim: limit,
        pg: page,
      };

      const response =
        selectedModule === "bs"
          ? await getAllIntegrationsBs(params)
          : selectedModule === "nm"
          ? await getAllIntegrationsNm(params) :await getAllIntegrations(params);

      if (response?.success) {
        const list = response.data?.data || [];

        const accessMap = list.reduce((acc, item) => {
          acc[item.uiid] = item.status;

          return acc;
        }, {});

        setIntegrationData(list);
        setIntegrationAccess(accessMap);
      } else {
        setIntegrationData([]);
      }
    } catch (error) {
      showToast("Unable to fetch integration Data", "error");
      console.error("Error fetching integration data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (uiid, email) => {
    console.log(email, uiid);
    // if (!uiid) return;
    if (category === 11 && (type === 7 || type === 8)) {
      if (!email) return;
    } else {
      if (!uiid) return;
    }

    try {
      const response =
        selectedModule === "bs"
          ? await deleteIntegrationBs({ uiid, coll: "Integrationbs" })
          : await deleteIntegration({ uiid, coll: "Integration" });

      if (response?.success) {
        showToast("Integration deleted successfully", "success");
        fetchIntegrationData();
      } else {
        showToast("Failed to delete integration", "error");
      }
    } catch (error) {
      console.warn("Error while deleting integration: ", error);
      showToast("Failed to delete integration", "error");
    }
  };

  const toggleIntegrationAccess = async (uiid, status) => {
    const key = uiid;
    const newintegrationAccess = { ...integrationAccess, [uiid]: status };

    try {
      const payload = [
        {
          type: "SET",
          value: { status },
        },
      ];
      setLoading(true);

      let updateStatus;
      if (selectedModule === "bs") {
        updateStatus = await updateIntegrationsBs({ uiid, payload });
      } else if (selectedModule ==="nm"){
                updateStatus = await updateIntegrationsNm({ uiid, payload });

      } else {
        updateStatus = await updateIntegrations({ uiid, payload });
      }

      if (updateStatus?.success) {
        setIntegrationAccess(newintegrationAccess);
        showToast("Integration status updated successfully", "success");
        setLoading(false);
      } else {
        showToast("Failed to update Integration status", "error");
        setLoading(false);
      }
    } catch (err) {
      console.error("Error updating integration status:", err);
      showToast("Failed to update Integration status", "error");
      setLoading(false);
    }
  };

  const getServiceName = () => {
    const configs = {
      3: {
        1: "Monster",
        2: "Shine",
        3: "Naukri",
        4: "LinkedIn",
        5: "ZipRecruiter",
        6: "Jora",
        7: "Career Builder",
      },
      11: {
        1: "G-suite",
        2: "Outlook",
        3: "Mailgun",
        4: "AWS SES",
        5: "Instantly",
        6: "Send Grid",
        // 7: "Nodemailer",
        7: "Gmail",
        8: "Outlook",
      },
      1: { 1: "VOIP Office CRM", 2: "ZOOM" },
      2: { 1: "VOIP Office CRM" },
      7: { 1: "Google Search API" },
    };
    return configs[category]?.[type] || "Service";
  };

  const serviceName = getServiceName();

  const tableColumn = [
    {
      key: "actions",
      label: "",
      columnMenu: false,
      render: (row) => (
        <DropdownMenuNew
          MenuSection={
            <div className="flex flex-col">
              <Button
                title={"Add Users"}
                icon={"group_add"}
                variant="text"
                color="black"
                size="sm"
                className="!justify-start py-1"
                onClick={() => {
                  setEditData(integrationData[row.id]);
                  // setEditData(integrationData.find(item => item.uiid === row.uiid));
                  setIsModalOpen(true);
                }}
              />

              <Button
                title={"Edit"}
                icon={"edit_square"}
                variant="text"
                color="black"
                size="sm"
                className="!justify-start py-1"
                onClick={() => {
                  setShowConnectModal(true);
                  setEditData(integrationData[row.id]);
                  // setEditData(integrationData.find(item => item.uiid === row.uiid));
                  setIsEdit(true);
                }}
              />

              <Button
                title={"Delete"}
                icon={"delete"}
                variant="text"
                color="black"
                size="sm"
                className="!justify-start py-1"
                onClick={() => {
                  category === 11 && (type === 7 || type === 8)
                    ? handleDelete(row.uiid, row.usersEmail)
                    : handleDelete(row.uiid);
                }}
              />
            </div>
          }
        >
          <Button
            type="icon"
            variant="text"
            icon={"more_vert"}
            color="black"
            label="true"
          />
        </DropdownMenuNew>
      ),
    },
    {
      key: "accountName",
      label: "Account Name",
      columnMenu: false,
    },
    // { key: "usersEmail", label: "Users Email", columnMenu: false },
    {
      key:
        category === 11 && (type === 7 || type === 8)
          ? "usersEmail"
          : "accountName",
      label:
        category === 11 && (type === 7 || type === 8)
          ? "Users Email"
          : "Display Name",
      columnMenu: false,
    },
    { key: "noofUsers", label: "No of Users", columnMenu: false },
    {
      key: "access",
      label: "Access",
      columnMenu: false,
      render: (row) => (
        <div className="flex items-center">
          <Button
            type="icon"
            variant="text"
            icon={row.status === 1 ? "toggle_on" : "toggle_off"}
            color={row.status === 1 ? "success" : "black"}
            // icon={"toggle_on"}
            // color={toggleOn.includes(row.id) ? "success" : "color"}
            // color="black"
            size="sm"
            onClick={() =>
              toggleIntegrationAccess(
                row.uiid,
                row.status === 1 ? 2 : 1,
                row.usersEmail,
              )
            }
            // onClick={() => handleStatusToggle(row)}
          />
        </div>
      ),
    },
    // {
    //   key:"menu",
    //   label:"",
    //   columnMenu:false,
    //   render:(row)=>(
    //       <div className="text-center text-xl cursor-pointer hover:text-gray-600">
    //     ⋯
    //   </div>
    // ),

    // }
  ];
  const categoryTypes = {
    11: {
      1: "G-suite",
      2: "Outlook",
      3: "Mailgun",
      4: "AWS SES",
      5: "Instantly",
      6: "Send Grid",
      // 7: "Nodemailer",
      7: "Gmail",
      8: "Outlook",
    },
  };

  const rowDat = Array.from({ length: integrationData?.length }, (_, i) => ({
    id: i,
    // accountName: categoryTypes[category]?.[type] || "-",
    // accountName:integrationData?.[i]?.displayName,
    accountName:
      category === 11 && type === 7
        ? integrationData?.[i]?.name
        : categoryTypes[category]?.[type] || "-",
    displayName: formatWords2(integrationData?.[i]?.name) || "-",
    usersEmail: integrationData?.[i]?.email,
    noofUsers: integrationData?.[i]?.accessIds?.length || "-",
    access: `User ${i + 1}`,
    _id: integrationData?.[i]?._id,
    uiid: integrationData?.[i]?.uiid,
    // status: integrationAccess[integrationData?.[i]?.uiid],
    status: integrationAccess[integrationData?.[i]?.uiid],
  }));

  const mappedrows = mapTableRows(rowDat, tableColumn);
  const handleSave = (data) => {
    onUpdate(data, () => {
      fetchIntegrationData();
      fetchTotalCount();
    });
    setShowConnectModal(false);
    // setShowTable(true);
  };

  if (
    selectedModule === "bs" &&
    type !== 1 &&
    type !== 2 &&
    type !== 7 &&
    type !== 8
  ) {
    return (
      <div className="mt-3">
        <p>
          This feature is not available for Bench Sales. However, you can
          configure the following features:
        </p>
        <div className="ms-3">
          <h6 className="text-dark my-2 -ms-1">
            Available Features for Bench Sales:
          </h6>
          <p>
            1. <strong>Kult AI (Text)</strong> — Marketplace &gt; AI (Beta) &gt;
            Kult AI (Text) &gt; Setup / Configure
          </p>
          <p>
            2. <strong>Apollo</strong> — Marketplace &gt; Productivity &gt;
            Apollo &gt; Setup / Configure
          </p>
          <p>
            3. <strong>G-Suite</strong> — Marketplace &gt; Bulk Email &gt;
            G-Suite &gt; Setup / Configure
          </p>
          <p>
            4. <strong>Outlook</strong> — Marketplace &gt; Bulk Email &gt;
            Outlook &gt; Setup / Configure
          </p>
        </div>
      </div>
    );
  }

  return (
    <div>
      {!integrationData || integrationData?.length <= 0 ? (
        <>
          <div className="flex justify-end items-center gap-2 mb-1">
            {/* <div className="w-[120px]">
          <FormFieldSet
            type="select"
            noTitle
            placeholder="Select"
            size="sm"
            options={[
              { label: "Monster", value: 1 },
              { label: "Foundit", value: 2 },
              { label: "Linkedin", value: 3 },
              { label: "Naukri", value: 4 },
              { label: "Jora", value: 5 },
              { label: "Career Builder", value: 6 },
            ]}
            shadow={true}
          />
        </div> */}
            <Button
              title={`Connect ${serviceName}`}
              size="sm"
              onClick={() => setShowConnectModal(true)}
            />
          </div>
          <p>
            Integration with {serviceName} for resume search is a
            straightforward process through Tektree Inc. Follow these steps.
          </p>
          <div className="font-bold mt-5 mb-2">
            Here are the steps to configure the Integrations
          </div>
          <ol className="list-decimal list-inside">
            <li>
              Contact your {serviceName} Account Manager to initiate the
              process.
            </li>
            <li>Request the necessary credentials.</li>
            <li>
              Click on <b>"Connect {serviceName}"</b> and provide the necessary
              details.
            </li>
            <li>
              Save the entered information to add your account successfully.
            </li>
            <li>
              Once saved, you can allocate credits to your team for utilization.
            </li>
            <li>
              Get ready to find top talent with {serviceName}'s extensive
              network and tools.
            </li>
          </ol>
        </>
      ) : 
      // loading ? (
      //   <div className="flex-1 flex justify-center items-center">
      //     <LogoLoader />
      //   </div>
      // ) :
       (
        <TableAdv
          columns={tableColumn}
          rows={mappedrows}
          showSlNo={false}
          showCheckbox={false}
          serverPagination={true}
          totalCount={totalCount}
          isLoading={loading}
          page={page}
          limit={limit}
          onPaginationChange={setPage}
          onLimitChange={handleLimitChange}
          toolbarRight={{
            search: false,
            add: [
              {
                component: (
                  <Button
                    title={"Add Account"}
                    size="sm"
                    onClick={() => {
                      setShowConnectModal(true);
                      setEditData();
                      setIsEdit(false);
                    }}
                  />
                ),
              },
            ],
          }}
        />
      )}

      <AddAccountModel
        isOpen={showConnectModal}
        onClose={() => setShowConnectModal(false)}
        category={category}
        type={type}
        existingData={editData ? editData : null}
        // existingData={integration}
        // onSave={onUpdate}
        onSave={handleSave}
        // isEditMode={!!integration}
        isEditMode={isEdit}
        selectedModule={selectedModule}
      />
      {/* <AddUsersListModel
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        showConnectModal={() => setShowConnectModal(true)}
      /> */}
      <AddBulkList
        isOpen={isModalOpen}
        existingData={editData ? editData?.uiid : null}
        category={category}
        type={type}
        onClose={() => {
          setIsModalOpen(false);
          fetchIntegrationData();
        }}
        onValueChange={(val) => setValueChange(val)}
        showConnectModal={() => setShowConnectModal(true)}
        selectedModule={selectedModule}
      />
    </div>
  );
};

export default BulkEmail;
